import { SyncDescriptor } from 'vscode/vscode/vs/platform/instantiation/common/descriptors';
import { IBulkEditService } from 'vscode/vscode/vs/editor/browser/services/bulkEditService';
import { BulkEditService } from './vscode/src/vs/workbench/contrib/bulkEdit/browser/bulkEditService.js';
import './vscode/src/vs/workbench/contrib/bulkEdit/browser/preview/bulkEdit.contribution.js';

function getServiceOverride() {
    return {
        [( IBulkEditService.toString())]: new SyncDescriptor(BulkEditService, [], true)
    };
}

export { getServiceOverride as default };
